import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updatedStatus: [],
  allupdatedStatus: []
};

export const updatedStatusSlice = createSlice({
  name: "updatedStatus",
  initialState,
  reducers: {
    getAllupdatedStatusAction: (state, action) => {
      state.allupdatedStatus = action.payload;
    },
  },
});

export default updatedStatusSlice.reducer;

export const { getAllupdatedStatusAction } = updatedStatusSlice.actions;
